import { AbstractControl, FormGroup, Validators } from '@angular/forms';

export type FieldMode = 'required' | 'optional' | 'hidden';
export const profileFieldDefaults: Record<string, FieldMode> = {
  street: 'required', city: 'required', state: 'required', zip: 'required', country: 'required',
  dateOfBirth: 'required', gender: 'required', maritalStatus: 'optional', occupation: 'optional', email: 'optional',
  language: 'optional', picture: 'optional'
};
export const profileFieldSections = [
  { title: 'Address', fields: ['street', 'city', 'state', 'zip', 'country'] },
  { title: 'Personal details', fields: ['dateOfBirth', 'gender', 'maritalStatus', 'occupation', 'picture'] },
  { title: 'Contact & preferences', fields: ['email', 'language'] }
];
export const profileFieldLabels = {
  street: 'Street', city: 'City', state: 'State / Province', zip: 'ZIP / Postal code', country: 'Address country',
  dateOfBirth: 'Date of birth', gender: 'Gender', maritalStatus: 'Marital status', occupation: 'Occupation', picture: 'Profile picture',
  email: 'Email', language: 'Preferred language'
};
export function readProfilePolicy(json?: string): Record<string, FieldMode> {
  const result = { ...profileFieldDefaults };
  try {
    const saved = JSON.parse(json || '{}');
    Object.keys(result).forEach(key => {
      if (['required', 'optional', 'hidden'].includes(saved?.[key])) result[key] = saved[key];
    });
  } catch { /* Existing churches use the defaults until settings are saved. */ }
  return result;
}
const policyDisabled = new WeakSet<AbstractControl>();
export function applyProfilePolicy(form: FormGroup, policy: Record<string, FieldMode>) {
  Object.keys(profileFieldDefaults).forEach(key => {
    const control = form.get(key);
    if (!control) return;
    const mode = policy[key] || profileFieldDefaults[key];
    control.removeValidators(Validators.required);
    if (mode === 'required') control.addValidators(Validators.required);
    if (mode === 'hidden' && control.enabled) {
      control.disable({ emitEvent: false });
      policyDisabled.add(control);
    } else if (mode !== 'hidden' && policyDisabled.has(control)) {
      control.enable({ emitEvent: false });
      policyDisabled.delete(control);
    }
    control.updateValueAndValidity({ emitEvent: false });
  });
}
